import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { AccountPlanService } from '../data/account-plan.service';
import { accountPlanCommand } from './account-plan.command';

@Injectable()
export class CopyAccountPlanCommandHandler implements ICommandHandler {
  constructor(private _service: AccountPlanService) {}

  canExecute(command: Command): boolean {
    return command.id === accountPlanCommand.copy && command.context;
  }

  execute(command: Command): Observable<boolean> {
    return this._service.copy(command.context.id).pipe(
      map(status => {
        command.context.status = status;
        return true;
      })
    );
  }
}
